import React from 'react';
import { H6 } from '@upsolve/ui'

// Don't display average time to read if it's computed to be more than 5 minutes
const MAX_TIME_TO_READ = 5;

// Average words an adult reads per minute is 200-250. We're being very liberal
// in our estimate here.
const AVG_WORDS_PER_MINUTE = 250;

function getEstTimeToRead(wordCount) {
  //
  return Math.max(Math.floor(wordCount / AVG_WORDS_PER_MINUTE), 1);
}

export default function TimeToRead({ wordCount }) {
  const timeToRead = getEstTimeToRead(wordCount);
  if (timeToRead > MAX_TIME_TO_READ || !wordCount) {
    return null;
  }

  return <H6>{timeToRead} minute read</H6>
}
